module.exports = __webpack_public_path__ + "static/img/epidemic-4.8ca3c1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/epidemic-4.png
// module id = Ey4W
// module chunks = 1